module.exports = __webpack_public_path__ + "static/img/pic-homepage-event.2e34d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-homepage-event.png
// module id = 967
// module chunks = 0